
let Warehouses =[
    {code:1, name:"Kortrijk"},
    {code:2, name:"Roeselare"},
    {code:3, name:"Oostende"},
    {code:4, name:"Brugge"},
    {code:5, name:"Knokke"},
    {code:6, name:"Gent"},
    {code:7, name:"Waregem"},
    {code:8, name:"Antwerpen"},
    {code:11, name:"Stasegem"},
    {code:99, name:"ECommerce"},
];
export function authHeader() {
    // return authorization header with basic auth credentials
    let user = JSON.parse(localStorage.getItem('user'));
    if (user && user.authdata) {
        return {
            'Content-Type': 'application/json',

            'Authorization': 'Basic ' + user.authdata };
    } else {
        return {};
    }
}

export function Warehouse()
{
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.authdata) {
        let obj = Warehouses.find(o => o.code === user.defaultWarehouseId);
        return obj.name;

    } else {
        return {};
    }
}



export function Username()
{
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.authdata) {

        return user.firstname + " " + user.lastname ;

    } else {
        return {};
    }
}